<header motif-header [fixed]="true" appHeaderName="Fund Audit" style="height: 4.4rem;">
  <button
    aria-controls="vertical-navigation-menu"
    motif-header-menu
    aria-label="Open Main Menu"
    tabindex="0"
    role="button"
    (click)="toggleSidebar(expanded)"
    position="left" [attr.aria-expanded]="showMenu"
  >
    <motif-icon [src]="'/assets/images/hamburger.svg'"></motif-icon>
  </button>
   <!-- Logo -->
  <div position="left" 
    class="header-logo-title"
  >
    <img motif-header-logo
         alt="Product name"
         src="./assets/images/ey-logo-inverted.svg"
         position="left"
    >
    <span motif-header-title position="left" style="font-size: 1.3rem;">Fund Audit</span>
  </div>
  <motif-header-logo>
    <a routerLink="/" tabindex="0" aria-label="Home Page Link">
      <img src="./assets/images/ey-logo-inverted.svg" alt="EY Motif Logo" />
    </a>
  </motif-header-logo>
  <!-- Icons slot -->
    
    <!-- logout option -->
  <div motif-header-icon position="right" class="user-details">{{user.name ? user.name.split(' ')[0] : ''}}
  </div>
  <span motif-header-icon position="right" class="user-icon"><motif-icon [src]="'/assets/images/person_outline.svg'"></motif-icon></span>
  <button
    motif-header-icon
    position="right"
    class="user-details"
    (click)="showUserDetail = !showUserDetail"
  >
    <motif-icon  style="display: flex;"
        [src]="'/assets/images/down-arrow copy.svg'"
    ></motif-icon>
  </button>
  <!-- Commenting this as currently backend is not ready. -->
    <!-- add notification -->
  <!-- <button
    motif-header-icon
    position="right"
    (click)="addNotificationTemp()"
  >
    <motif-icon
    [src]="'/assets/images/notification_add.svg'"
    ></motif-icon>
  </button> -->
    <!-- app notifications icon -->
  <!-- <button
    motif-header-icon
    position="right"
    (click)="showModal = !showModal"
  >
    <motif-icon
      class="app-notification-bell-icon"
      [src]="'/assets/images/notification.svg'"
    >
      <motif-badge
        type="success"
        [number]="notificationCount"
        [overlap]="true"
      ></motif-badge>
    </motif-icon>
  </button>  -->
  <button
    motif-header-icon
    position="right"
    (click)="showBulkDownloadModal = !showBulkDownloadModal"
  >
    <!-- bulk download progress icon -->
    <motif-icon class="app-notification-bell-icon download-progress"
     [src]="'/assets/images/download_header.svg'" 
     >
      <motif-badge type="success"
        [number]="bulkDownloadService.jobIdsInProgress.length"
        [overlap]="true"
        [ngClass]="{'pulse-badge': bulkDownloadService.jobIdsInProgress.length > 0}">
      </motif-badge>
    </motif-icon>
  </button>
  <!-- Sidebar -->

  <!-- Menu -->
</header>
<nav
  motif-vertical-navigation
  id="vertical-navigation-menu"
  class="vertical-navigation-menu"
  [show]="expanded" 
>
  <ul motif-vertical-navigation-menu position="top">
  @for (item of menuOptions; track item?.label) {
    <ng-container *ngTemplateOutlet="itemTemplate; context: {item, index: $index}">
    </ng-container>
}
    <ng-template #itemTemplate let-item="item">
      <li motif-vertical-navigation-menu-item>
          <a motif-vertical-navigation-menu-link [routerLink]="item.routerLink" vertical-navigation-menu-item-active
             [verticalNavigationMenuItemActiveOptions]="{exact: item.exact}"
             [motif-tooltip]="!expanded ? item?.label : ''" placement="right" [hideIconClose]="true"
             [id]="'nav-tooltip'">
              @if (item?.icon) {
                  <motif-icon [src]="item?.icon"
                  stroke="none"
                  fill="#fff"
                  size="16"></motif-icon><span>{{item?.label}}</span>
              }
          </a>
      </li>
  </ng-template>

  </ul>

  <ng-content></ng-content>
<!-- </motif-vertical-navigation> -->
</nav>
<!-- notification modal -->
<app-modal
  *ngIf="showModal"
  [showModal]="true"
  [top]="60"
  [modalBodyTopPosition]="2"
  [modalBodyRightPosition]="10"
  (closeModal)="showModal = false"
>
  <app-notification (closeModel)="showModal = $event"></app-notification>
</app-modal>
<app-modal
  *ngIf="showUserDetail"
  [showModal]="true"
  [top]="60"
  [modalBodyTopPosition]="2"
  [modalBodyRightPosition]="30"
  [modalBodyWidth]="350"
  (closeModal)="showUserDetail = false"
>
  <app-user-info [user]="user" [logout]="logout.bind(this)" (closeModel)="showUserDetail = $event"></app-user-info>
</app-modal>
<!-- notification-popup -->
<div class="notifications">
  <div *ngFor="let notification of newNotifications" class="notification">
    <ng-container
      *ngTemplateOutlet="
        notificationTpl;
        context: { notification: notification }
      "
    ></ng-container>
  </div>
</div>

<ng-template #notificationTpl let-notification="notification">
  <motif-card
    [ngClass]="{
      'card-expanded':
        notification.isExpanded &&
        (removeSpace(notification.groupType).toUpperCase() ===
          groupTypes[groupTypes.fundRequest].toUpperCase() ||
          removeSpace(notification.groupType).toUpperCase() ===
            groupTypes[groupTypes.workpaper].toUpperCase())
    }"
    (click)="navigateToFundDetails(notification)"
  >
    <motif-card-body>
      <div class="card-header-row">
        <div class="group-type">
          <motif-chip [removeable]="false" variant="success">
            <span class="group-type-name">{{
              notification.groupType
            }}</span></motif-chip
          >
        </div>
        <div class="close-icon">
          <button aria-label="icon-button" (click)="close(notification)">
            <motif-icon
              [src]="'/assets/icons/navigation/ic_close_24px.svg'"
            ></motif-icon>
          </button>
        </div>
      </div>
      <div class="card-footer-row">
        <div class="motif-h6 card-title">
          {{ notification.clientName + " | " + notification.administrator }}
        </div>
        <button
          aria-label="icon-button"
          (click)="toggleNotificationPopUp(notification, $event)"
        >
          <motif-icon
            *ngIf="!notification.isExpanded"
            [src]="'/assets/icons/navigation/ic_expand_more_24px.svg'"
          ></motif-icon>
          <motif-icon
            *ngIf="notification.isExpanded"
            [src]="'/assets/icons/navigation/ic_expand_less_24px.svg'"
          ></motif-icon>
        </button>
      </div>
      <motif-accordion type="editorial" togglePosition="after">
        <motif-expansion-panel [(expanded)]="notification.isExpanded">
          {{ notification.description }}
        </motif-expansion-panel>
      </motif-accordion>
    </motif-card-body>
  </motif-card>
</ng-template>


<app-modal
  *ngIf="showBulkDownloadModal"
  [showModal]="true"
  [top]="60"
  [modalBodyTopPosition]="2"
  [modalBodyRightPosition]="5"
  [modalBodyWidth]="420"
  (closeModal)="showBulkDownloadModal = false"
>
  <div class="bulk-download-container">
    <h3 class="bulk-download-title">Bulk Download Progress Status</h3>
    <ul class="bulk-download-list">
      <li
        *ngFor="let job of bulkDownloadService.jobIdsInProgress"
        class="bulk-download-item"
      >
        <motif-card>
          <motif-card-body>
            <div>
              <strong>Job ID:</strong>
              <span class="job-id-label">{{ job.jobId }}</span>
            </div>
            <div class="job-status">
              <strong>Status:</strong>
               <span class="job-status-label">
                <span [ngClass]="{
                  'status-default': job.status === 'MSG_SENT_TO_TOPIC',
                  'status-in-progress': job.status === 'MSG_RECEIVED_BY_CONSUMER',
                  'status-completed': job.status === 'SYSTEM_DOWNLOAD_STARTED' || job.status === 'SYSTEM_DOWNLOAD_COMPLETED',
                  'status-failed': job.status === 'FAILED'
                }">
                {{
                  job.status === 'MSG_SENT_TO_TOPIC' ? 'Pending' :
                  job.status === 'MSG_RECEIVED_BY_CONSUMER' ? 'In Progress' :
                  job.status === 'SYSTEM_DOWNLOAD_STARTED' ? 'Downloading files in your system...' :
                  job.status === 'SYSTEM_DOWNLOAD_COMPLETED' ? 'Download Completed' :
                  job.status === 'FAILED' ? 'Failed' : ''
                }}
              </span>
            </span>
            </div>
          </motif-card-body>
        </motif-card>
      </li>
    </ul>
      <div *ngIf="bulkDownloadService.jobIdsInProgress.length === 0" class="no-downloads-message">
      No downloads in progress.
    </div>
  </div>
</app-modal>
<main >
  <router-outlet></router-outlet>
</main>
